import { Route, Switch, useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'
import { useCallback, useMemo } from 'react'

import { api } from '@h2/api'
import { Loader } from '@h2/components/loading/loader'

import { BudgetCounty } from '../county'
import { BudgetResults } from '../results'
import { BudgetSummary } from '../summary'
import { BudgetQuestion } from '../question'
import { BudgetReverse } from '../reverse'

const RequireBudgetWrapper = () => {
  const { budgetId } = useParams()
  const queryClient = useQueryClient()
  const { data: budget, isFetching: isBudgetFetching } = useQuery(
    ['user-budget', budgetId],
    () => {
      return api.fetch(`/budget/${budgetId}`, {
        method: 'GET'
      })
    }
  )
  /**
   * This will update the budget in react query, and is passed to the routes
   * so there is a simple method to make the update
   * @type {(function(*): void)|*}
   */
  const updateBudget = useCallback(
    newBudget => {
      queryClient.setQueryData(['user-budget', budgetId], newBudget)
    },
    [queryClient, budgetId]
  )
  const budgetProps = useMemo(
    () => ({
      budget,
      isBudgetFetching,
      updateBudget
    }),
    [budget, updateBudget, isBudgetFetching]
  )
  const routes = [
    {
      path: '/budget/:budgetId?/location',
      exact: true,
      render(props) {
        return <BudgetCounty {...budgetProps} {...props} />
      }
    },
    {
      path: '/budget/:budgetId/results',
      exact: true,
      render(props) {
        return <BudgetResults {...budgetProps} {...props} />
      }
    },
    {
      path: '/budget/:budgetId/question/:questionId',
      exact: true,
      render(props) {
        return <BudgetQuestion {...budgetProps} {...props} />
      }
    },
    {
      path: '/budget/:budgetId/summary',
      exact: true,
      render(props) {
        return <BudgetSummary {...budgetProps} {...props} />
      }
    },
    {
      path: '/budget/:budgetId?/reverse',
      exact: true,
      render(props) {
        return <BudgetReverse {...budgetProps} {...props} />
      }
    }
  ]

  if (isBudgetFetching) {
    return <Loader />
  }

  return (
    <Switch>
      {routes.map((route, idx) => (
        <Route
          key={idx}
          {...route}
          render={props => {
            return route.render({ ...props })
          }}
        />
      ))}
    </Switch>
  )
}

export { RequireBudgetWrapper }
